import { StatusBadge, StatusBadgeVariant } from "components/StatusBadge";
import {
  StatusLoteTaxa,
  StatusLoteTaxaLabel,
} from "./enums/StatusLoteTaxa.enum";

interface IProps {
  status: number;
  width?: string;
}

const variantePorStatus: Record<number, StatusBadgeVariant> = {
  [StatusLoteTaxa.PENDENTE]: "aviso",
  [StatusLoteTaxa.FINALIZADO]: "sucesso",
};

export function StatusLotePagamento({ status, width }: IProps) {
  const texto = StatusLoteTaxaLabel[status] ?? StatusLoteTaxaLabel[StatusLoteTaxa.PENDENTE];
  const variant = variantePorStatus[status] ?? variantePorStatus[StatusLoteTaxa.PENDENTE];
  return <StatusBadge label={texto} variant={variant} width={width} />;
}
